import {DTO} from '@/shared/base/dto';
import {ENDPOINT, METHOD} from '@/constants';
import {
  IBodyCreateDepartment,
  IBodyUpdateDepartment,
  IQueryGetTenant,
  IQueryGetDepartmentAssign,
  IQueryGetAllHistoryBlockLimit,
} from '@/types';
import {IQueryGetTenantUsageDetail} from '@/types/common/department';

export class GetTenantResponse {
  public readonly data: object | undefined;
}
export class GetProfileTenantDTO extends DTO {
  public url = ENDPOINT.TENANT_ME;
  public method = METHOD.GET;
  public body: undefined;
  public query: undefined;
  public param: undefined;
}
export class UpdateProfileTenantDTO extends DTO {
  public body: {isActive: boolean};
  public url: string = ENDPOINT.TENANT_ME;
  public method = METHOD.PUT;
  public param: undefined;
  public query: undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(body: any) {
    super();
    this.body = body;
  }
}
export class GetDepartmentListDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.DEPARTMENT;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: IQueryGetTenant;
  constructor(query: IQueryGetTenant) {
    super();
    this.query = query;
  }
}

export class GetDepartmentUsageDetailListDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.DEPARTMENT_USAGE_DETAIL;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: IQueryGetTenantUsageDetail;
  constructor(query: IQueryGetTenantUsageDetail) {
    super();
    this.query = query;
  }
}

export class GetExcelDepartmentUsageDetailListDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.DEPARTMENT_EXCEL_USAGE_DETAIL;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: IQueryGetTenantUsageDetail;
  constructor(query: IQueryGetTenantUsageDetail) {
    super();
    this.query = query;
    this.responseType = 'blob';
  }
}

export class GetPdfDepartmentUsageDetailListDTO extends GetExcelDepartmentUsageDetailListDTO {
  public url = ENDPOINT.DEPARTMENT_PDF_USAGE_DETAIL;
}

export class GetListDepartmentAssignDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.ASSIGN_DEPARTMENT;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: IQueryGetDepartmentAssign;
  constructor(query: IQueryGetDepartmentAssign) {
    super();
    this.query = query;
  }
}
export class GetDepartmentCompactDTO extends DTO {
  public url = ENDPOINT.GET_DEPARTMENT_COMPACT;
  public method = METHOD.GET;
  public body: undefined;
  public param: undefined;
  public query: {withUsage?: boolean};
  constructor(query: {withUsage?: boolean}) {
    super();
    this.query = query;
  }
}

export class CreateDepartmentDTO extends DTO {
  public static url = ENDPOINT.DEPARTMENT;
  public url = ENDPOINT.DEPARTMENT;
  public method = METHOD.POST;
  public query: undefined;
  public param: undefined;

  constructor(public body: IBodyCreateDepartment) {
    super();
  }
}

export class UpdateDepartmentDTO extends DTO {
  public body: IBodyUpdateDepartment;
  public url: string = ENDPOINT.DEPARTMENT_UPDATE;
  public method = METHOD.PUT;
  public param: {id: number | undefined};
  public query: undefined;
  constructor(param: {id: number | undefined}, body: IBodyUpdateDepartment) {
    super();
    this.param = param;
    this.body = body;
  }
}

export class GetDepartmentByIdDTO extends DTO {
  public param: {id: number} | undefined;
  public url = ENDPOINT.DEPARTMENT_UPDATE;
  public method = METHOD.GET;
  public body: undefined;
  public readonly responseClass: unknown;
  public query: undefined;
  constructor(param: {id: number}) {
    super();
    this.param = param;
  }
}

export class DeleteDepartmentDTO extends DTO {
  public param: {id: number} | undefined;
  public url = ENDPOINT.DEPARTMENT_UPDATE;
  public method = METHOD.DELETE;
  public body: undefined;
  public readonly responseClass: unknown;
  public query: undefined;
  constructor(param: {id: number}) {
    super();
    this.param = param;
  }
}

export class GetAllBlockLimitHistoryDTO extends DTO {
  public url = ENDPOINT.BLOCK_LIMIT_EDIT_HISTORY;
  public method = METHOD.GET;
  public body: undefined;
  public query: IQueryGetAllHistoryBlockLimit;
  public param: undefined;
  constructor(query: IQueryGetAllHistoryBlockLimit) {
    super();
    this.query = query;
  }
}
